<template>
  <div class="view-synthesis" @click="user_menu_visible = false">
    <div class="header">
      <div class="back" @click="back()">
        <icon file="arrow-left" :size="32" />
      </div>
      <h1>Vos documents</h1>
    </div>
    <div class="content files">
      <div class="row">
        <div class="col one-third">
          <h3>Synthèses</h3>
          <ul>
            <li v-for="s in synthesis_file_list" :key="s.id">
              <div class="row">
                <div class="col one-dec">
                  <!-- <icon file="file-text" :size="48" /> -->
                  <div class="file-logo" v-html="require('../assets/img/files-types/'+s.ext+'.svg')"></div>
                </div>
                <div class="col nine-dec">
                  <p>
                    <a @click="triggerGtm('Synthèse', s.title)" :href="s.url" target="_blank">{{ s.title }}</a>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="false" class="col one-third">
          <h3>Données</h3>
          <ul>
            <li v-for="s in data_file_list" :key="s.id">
              <div class="row">
                <div class="col one-dec">
                  <!-- <icon file="file-text" :size="48" /> -->
                  <div class="file-logo" v-html="require('../assets/img/files-types/'+s.ext+'.svg')"></div>
                </div>
                <div class="col nine-dec">
                  <p>
                    <a @click="triggerGtm('Donnée', s.title)" :href="s.url" target="_blank">{{ s.title }}</a>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="false" class="col one-third">
          <h3>Etudes</h3>
          <ul>
            <li v-for="s in etude_file_list" :key="s.id">
              <div class="row">
                <div class="col one-dec">
                  <!-- <icon file="file-text" :size="48" /> -->
                  <div class="file-logo" v-html="require('../assets/img/files-types/'+s.ext+'.svg')"></div>
                </div>
                <div class="col nine-dec">
                  <p>
                    <a @click="triggerGtm('Donnée', s.title)" :href="s.url" target="_blank">{{ s.title }}</a>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Filters from "@/components/search/filters";
import Search from "@/components/search";
import Etude from "@/components/etude";

const publicPath = process.env.BASE_URL;
const synthesis_files = [
  {
    id: 100,
    url: `${publicPath}files/cdc-habitat-adequation-bilan2019.pdf`,
    ext: "pdf",
    title: "CdC Habitat -Adéquation - Bilan 2019.pdf"
  },
  {
    id: 110,
    url: `${publicPath}files/bilan-des-differences-etudes-grilles-locatives-avril-2019.pdf`,
    ext: "pdf",
    title: "Bilan des différences études-grilles locatives - Avril 2019.pdf"
  },
  {
    id: 120,
    url: `${publicPath}files/cdc-habitat-adequation-bilan2018.pdf`,
    ext: "pdf",
    title: "CdC Habitat -Adéquation - Bilan 2018.pdf"
  },
  {
    id: 130,
    url: `${publicPath}files/seminaire-4-juillet-2018-marseille.pdf`,
    ext: "pdf",
    title: "Séminaire du 4 juillet 2018 - Marseille.pdf"
  },
  {
    id: 140,
    url: `${publicPath}files/etudes-potentiel-developpement-lli-2018.pdf`,
    ext: "pdf",
    title: "Etudes de potentiel de développement du LLI - 2018.pdf"
  },
  {
    id: 150,
    url: `${publicPath}files/cdc-habitat-adequation-bilan2017.pdf`,
    ext: "pdf",
    title: "CdC habitat - Adéquation - Bilan 2017.pdf"
  },
  {
    id: 160,
    url: `${publicPath}files/cdc-habitat-adequation-bilan2016.pdf`,
    ext: "pdf",
    title: "CdC Habitat - Adéquation - Bilan 2016.pdf"
  },
  {
    id: 170,
    url: `${publicPath}files/cdc-habitat-adequation-bilan2015.pdf`,
    ext: "pdf",
    title: "CdC Habitat - Adéquation - Bilan 2015.pdf"
  },
  {
    id: 180,
    url: `${publicPath}files/etudes-potentiel-developpement-lli-2014.pdf`,
    ext: "pdf",
    title: "Etudes de potentiel de développement du LLI - 2014.pdf"
  }
];

const data_files = [
  {
    id: 210,
    url: `${publicPath}files/mise-a-jour-loyers-par-communes-oct2020.xlsx`,
    ext: "xls",
    title: "Mise à jour loyers par communes - Oct 2020.xlsx"
  },
  {
    id: 230,
    url: `${publicPath}files/promotion-immobiliere-et-logement-social-oct2020.xlsx`,
    ext: "xls",
    title: "Promotion immobilière et logement social- Oct 2020.xlsx"
  }
];

const date = new Date().toISOString().substring(0, 10);
const etude_files = [
{
    id: 310,
    url: `${publicPath}files/etudes-2019.xlsx?date=${date}`,
    ext: "xls",
    title: "Etudes - 2019.xlsx"
  },
  {
    id: 320,
    url: `${publicPath}files/etudes-2020.xlsx?date=${date}`,
    ext: "xls",
    title: "Etudes - 2020.xlsx"
  },
   {
    id: 330,
    url: `${publicPath}files/etudes-2021.xlsx?date=${date}`,
    ext: "xls",
    title: "Etudes - 2021.xlsx"
  }
];


export default {
  name: "view-synthesis",
  data: function() {
    return {
      user_menu_visible: false,
      synthesis_file_list: synthesis_files,
      data_file_list: data_files,
      etude_file_list: etude_files.reverse(),
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "mode",
      "active_study",
      "query",
      "user_profile",
      "user_name"
    ]),
    query_string: {
      get() {
        return this.query;
      },
      set(newValue) {
        return this.$store.dispatch("set_query", { query: newValue });
      }
    },
    user_initials() {
      if (!!this.user_profile.firstname) {
        return `${this.user_profile.firstname[0]}${
          this.user_profile.lastname[0]
        }`;
      }
      return "";
    }
  },
  methods: {
    back: function() {
      this.$store.dispatch("remove_all_filters");
      this.$router.push({ name: "home" });
    },
    // launch_search: function() {
    // 	this.$store.dispatch("load_projects");
    // },
    triggerGtm(label, value) {
      this.$gtm.trackEvent({
				category: 'Synthèses',
				action: 'Click',
				label,
				value
			});
    }
  },
  components: {}
};
</script>

<style lang="stylus">
@import '../assets/css/app'
@import '../assets/css/grid'

.fade-enter, .fade-leave-to
  opacity 0

.slide-enter, .slide-leave-to
  transform translateX(100%)

.view-synthesis
  height 100%
  overflow scroll

  .header
    position absolute
    left 0
    right 0
    top 0
    background-color red
    height 80px + 40px
    text-align left
    padding ((@height - 56px) / 2) 0
    transition 0.25s easeOutQuart
    z-index 1001

    h1
      margin 16px 0px 16px 160px
      font-size 32px
      color white
      font-weight 400

    .back
      position absolute
      left 24px
      top 44px
      color #fff
      cursor pointer

  .content.files
    width 1728px

  .content
    top 120px

    h1
      padding-top 40px
      margin 0px 0px 40px 24px

    h3
      font-size 24px
      margin 12px 0px

    li
      list-style none

      .col
        border 1px
        // border-style: dotted;
        height 64px
        line-height 64px

      svg
        transform scale(1.3)
        height 64px

      p
        font-size 16px
        vertical-align bottom

    .file-logo
      text-align center
</style>
